angular.module("LeasePilot").directive("buildingFormModal", [
  "$mdDialog",
  "BuildingService",
  "BuildingHelperService",
  function($mdDialog, BuildingService, BuildingHelperService) {
    return {
      restrict: "E",
      templateUrl: "building_form_modal.html",
      scope: {
        type: "@",
        id: "@",
        building: "=?",
        displayName: "@?",
        dashboardName: "@?",
        landlordName: "@?", 
        landlordEntityType: "@?",
        landlordStateOfFormation: "@?",
        streetAddress: "@?",
        city: "@?",
        county: "@?",
        state: "@?",
        zipCode: "@?",
        municipalityType: "@?",
        buildingOfficeArea: "=?"
      },
      link: function($scope) {
        $scope.showMask = true;
        $scope.isProcessing = false;

        // Sanitize plain-text inputs: remove tags, Angular interpolations, javascript: URIs
        $scope.sanitize = function(value) {
          if (value === null || value === undefined) return '';
          var str = String(value);
          // Remove any HTML tags
          str = str.replace(/<[^>]*>/g, '');
          // Remove Angular-style interpolation expressions
          str = str.replace(/\{\{[\s\S]*?\}\}/g, '');
          // Neutralize javascript: URIs if any text tries to include them
          str = str.replace(/javascript:/gi, '');
          return str.trim();
        };

        function sanitizeAll() {
          $scope.displayName = $scope.sanitize($scope.displayName);
          $scope.dashboardName = $scope.sanitize($scope.dashboardName);
          $scope.landlordName = $scope.sanitize($scope.landlordName);
          $scope.landlordEntityType = $scope.sanitize($scope.landlordEntityType);
          $scope.landlordStateOfFormation = $scope.sanitize($scope.landlordStateOfFormation);
          $scope.streetAddress = $scope.sanitize($scope.streetAddress);
          $scope.city = $scope.sanitize($scope.city);
          $scope.county = $scope.sanitize($scope.county);
          $scope.state = $scope.sanitize($scope.state);
          $scope.zipCode = $scope.sanitize($scope.zipCode);
          $scope.municipalityType = $scope.sanitize($scope.municipalityType);
          if ($scope.buildingOfficeArea !== undefined && $scope.buildingOfficeArea !== null && $scope.buildingOfficeArea !== "") {
            var numeric = Number(String($scope.buildingOfficeArea).replace(/[^0-9.\-]/g, ''));
            $scope.buildingOfficeArea = isNaN(numeric) ? null : numeric;
          }
        }

        if ($scope.type === 'update' && $scope.building) {
          $scope.id = $scope.building.id;
          $scope.displayName = $scope.building.displayName;
          $scope.dashboardName = $scope.building.dashboardName;
          $scope.landlordName = $scope.building.landlordName;
          $scope.landlordEntityType = $scope.building.landlordEntityType;
          $scope.landlordStateOfFormation = $scope.building.landlordStateOfFormation;
          $scope.streetAddress = $scope.building.streetAddress;
          $scope.city = $scope.building.city;
          $scope.county = $scope.building.county;
          $scope.state = $scope.building.state;
          $scope.zipCode = $scope.building.zipCode;
          $scope.municipalityType = $scope.building.municipalityType;
          $scope.buildingOfficeArea = $scope.building.buildingOfficeArea;
        }

        if ($scope.type === 'update') {
          $scope.displayName = $scope.displayName || "";
          $scope.dashboardName = $scope.dashboardName || "";
          $scope.landlordName = $scope.landlordName || "";
          $scope.landlordEntityType = $scope.landlordEntityType || "";
          $scope.landlordStateOfFormation = $scope.landlordStateOfFormation || "";
          $scope.streetAddress = $scope.streetAddress || "";
          $scope.city = $scope.city || "";
          $scope.county = $scope.county || "";
          $scope.state = $scope.state || "";
          $scope.zipCode = $scope.zipCode || "";
          $scope.municipalityType = $scope.municipalityType || "";
          sanitizeAll();
        }

        const original = {
          id: $scope.id,
          displayName: $scope.displayName,
          dashboardName: $scope.dashboardName,
          landlordName: $scope.landlordName,
          landlordEntityType: $scope.landlordEntityType,
          landlordStateOfFormation: $scope.landlordStateOfFormation,
          streetAddress: $scope.streetAddress,
          city: $scope.city,
          county: $scope.county,
          state: $scope.state,
          zipCode: $scope.zipCode,
          municipalityType: $scope.municipalityType,
          buildingOfficeArea: $scope.buildingOfficeArea,
        };

        $scope.cancel = function() {
          if ($scope.type === "create") {
            window.track.event(new CancelCreateBuildingEvent());
          } else if ($scope.type === "update") {
            window.track.event(new CancelEditBuildingEvent({
              id: $scope.id,
            }));
          }
          $mdDialog.cancel();
        };

        $scope.validateBeforeCreate = async function() {
          sanitizeAll();
          const isValid = await BuildingHelperService.validate({
            type: "create",
            name: $scope.displayName || "",
            dashboardName: $scope.dashboardName || "",
            landlordName: $scope.landlordName || "",
            landlordEntityType: $scope.landlordEntityType || "",
            landlordStateOfFormation: $scope.landlordStateOfFormation || "",
            streetAddress: $scope.streetAddress || "",
            city: $scope.city || "",
            county: $scope.county || "",
            state: $scope.state || "",
            zipCode: $scope.zipCode || "",
            municipalityType: $scope.municipalityType || "",
            buildingOfficeArea: $scope.buildingOfficeArea,
          });

          $scope.$apply(() => {
            $scope.isValid = isValid;
          });
        };

        $scope.validateBeforeUpdate = async function() {
          sanitizeAll();
          const isValid = await BuildingHelperService.validate({
            type: "update",
            name: $scope.displayName || "",
            dashboardName: $scope.dashboardName || "",
            landlordName: $scope.landlordName || "",
            landlordEntityType: $scope.landlordEntityType || "",
            landlordStateOfFormation: $scope.landlordStateOfFormation || "",
            streetAddress: $scope.streetAddress || "",
            city: $scope.city || "",
            county: $scope.county || "",
            state: $scope.state || "",
            zipCode: $scope.zipCode || "",
            municipalityType: $scope.municipalityType || "",
            buildingOfficeArea: $scope.buildingOfficeArea,
          });

          $scope.$apply(() => {
            $scope.isValid = isValid;
          });
        };

        $scope.create = async function() {
          sanitizeAll();
          const isValid = await BuildingHelperService.validate({
            type: "create",
            name: $scope.displayName,
            dashboardName: $scope.dashboardName,
            landlordName: $scope.landlordName,
            landlordEntityType: $scope.landlordEntityType,
            landlordStateOfFormation: $scope.landlordStateOfFormation,
            streetAddress: $scope.streetAddress,
            city: $scope.city,
            county: $scope.county,
            state: $scope.state,
            zipCode: $scope.zipCode,
            municipalityType: $scope.municipalityType,
            buildingOfficeArea: $scope.buildingOfficeArea,
          });

          $scope.isValid = isValid;

          if (isValid.all) {
            $scope.$apply(() => {
              $scope.isProcessing = true;
            });

            
            const data = {
              displayName: $scope.displayName,
              dashboardName: $scope.dashboardName,
              landlordName: $scope.landlordName,
              landlordEntityType: $scope.landlordEntityType,
              landlordStateOfFormation: $scope.landlordStateOfFormation,
              streetAddress: $scope.streetAddress,
              city: $scope.city,
              county: $scope.county,
              state: $scope.state,
              zipCode: $scope.zipCode,
              municipalityType: $scope.municipalityType,
              buildingOfficeArea: $scope.buildingOfficeArea,
            };

            BuildingHelperService.create(data).then(
              response => {
                window.track.event(new CreateBuildingEvent(data));
                window.location.reload();
              },
              error => {
                console.error(error);
                $scope.$apply(() => {
                  $scope.error = error.message;
                  $scope.isProcessing = false;
                });
              }
            );
          }
        };

        $scope.update = async function() {
          sanitizeAll();
          const isValid = await BuildingHelperService.validate({
            type: "update",
            name: $scope.displayName,
            dashboardName: $scope.dashboardName,
            landlordName: $scope.landlordName,
            landlordEntityType: $scope.landlordEntityType,
            landlordStateOfFormation: $scope.landlordStateOfFormation,
            streetAddress: $scope.streetAddress,
            city: $scope.city,
            county: $scope.county,
            state: $scope.state,
            zipCode: $scope.zipCode,
            municipalityType: $scope.municipalityType,
            buildingOfficeArea: $scope.buildingOfficeArea,
          });

          $scope.isValid = isValid;

          if (isValid.all) {
            $scope.$apply(() => {
              $scope.isProcessing = true;
            });

            const data = {
              id: $scope.id,
              name: $scope.displayName,
              dashboardName: $scope.dashboardName,
              landlordName: $scope.landlordName,
              landlordEntityType: $scope.landlordEntityType,
              landlordStateOfFormation: $scope.landlordStateOfFormation,
              streetAddress: $scope.streetAddress,
              city: $scope.city,
              county: $scope.county,
              state: $scope.state,
              zipCode: $scope.zipCode,
              municipalityType: $scope.municipalityType,
              buildingOfficeArea: $scope.buildingOfficeArea,
            };

            const before = original;
            const after = data;

            BuildingHelperService.update(data).then(
              response => {
                window.track.event(new EditBuildingEvent({
                  before,
                  after,
                }));
                window.location.reload();
              },
              error => {
                console.error(error);
                $scope.$apply(() => {
                  $scope.error = error.message;
                  $scope.isProcessing = false;
                });
              }
            );
          }
        };

        $scope.createSupportTicket = function() {
          zendesk.state.go("zendesk");
          zendesk.sidenav.open();
        };
      }
    };
  }
]); 